import React, { useEffect } from 'react'

import { useApplicationContext } from '../../contexts/appContext'

export const EastVenturesCancel = () => {
  const { expire } = useApplicationContext()
  useEffect(() => {
    expire()
  }, [])

  return (
    <>
      <h2 className={'text-4xl sm:text-5xl mb-8 leading-tight'}>The process has been cancelled.</h2>
    </>
  )
}
